/* Gold & Richie — recently viewed
   Handles are kept in localStorage, so nothing about browsing history leaves the
   visitor's machine. Cards are fetched through the Section Rendering API so the
   markup matches every other product card on the site. */

(function () {
  var KEY = 'gr:recently-viewed';
  var MAX = 12;

  function read() {
    try {
      var raw = window.localStorage.getItem(KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (error) {
      return [];               /* private mode, or storage disabled */
    }
  }

  function write(list) {
    try { window.localStorage.setItem(KEY, JSON.stringify(list)); } catch (error) { /* no-op */ }
  }

  function remember(handle) {
    if (!handle) return;
    var list = read().filter(function (h) { return h !== handle; });
    list.unshift(handle);
    write(list.slice(0, MAX));
  }

  function render(section) {
    var rail = section.querySelector('[data-gr-recently-viewed-rail]');
    if (!rail) return;

    var exclude = section.dataset.exclude;
    var limit = parseInt(section.dataset.limit, 10) || 4;
    var handles = read().filter(function (h) { return h !== exclude; }).slice(0, limit);
    if (!handles.length) return;

    var root = (window.GR && GR.routes && GR.routes.root) || '/';

    Promise.all(handles.map(function (handle) {
      return fetch(root + 'products/' + handle + '?section_id=card-fragment')
        .then(function (response) { return response.ok ? response.text() : ''; })
        .catch(function () { return ''; });     /* a deleted product must not break the rail */
    })).then(function (chunks) {
      var html = chunks.join('');
      if (!html.trim()) return;
      rail.innerHTML = html;
      section.hidden = false;
    });
  }

  function start() {
    var body = document.body.className || '';
    if (body.indexOf('template-product') !== -1) {
      var canonical = document.querySelector('link[rel="canonical"]');
      var match = canonical && canonical.href.match(/\/products\/([^/?#]+)/);
      if (match) remember(decodeURIComponent(match[1]));
    }
    var sections = document.querySelectorAll('[data-gr-recently-viewed]');
    for (var i = 0; i < sections.length; i++) render(sections[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
